module.exports = __webpack_public_path__ + "img/Atif[1].3bf0bddf.jpg";